// import MainLayout from 'layout/MainLayout';
// import MinimalLayout from 'layout/MinimalLayout';
// import HeaderLayout from 'layout/HeaderLayout';
import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports

// import { Test } from 'views/admin-components/pages/Test';
// import LandingTestPage from 'views/user-components/LandingTestPage';
// import Home from 'views/user-components/pages/dashboard/Home';
// import ProfileFinalStep from 'views/user-components/pages/signup-profile/ProfileFinalStep';


import Loadable from 'ui-component/Loadable';

// const ProfileSteps = Loadable(lazy(() => import('views/user-components/pages/signup-profile/ProfileSteps')));
// const Test = Loadable(lazy(() => import('views/admin-components/pages/Test')));
const DashBoardLayout = Loadable(lazy(() => import('layout/DashboardLayout')));
const Home = Loadable(lazy(() => import('views/user-components/pages/dashboard/Home')));
const AssetAllocation = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocation')));
const AssetAllocationHome = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationMain')));
const EmployeeInfo = Loadable(lazy(() => import('views/user-components/pages/dashboard/EmployeeInfo')));
const MessageCenter = Loadable(lazy(() => import('views/user-components/pages/dashboard/MessageCenter')));
// const Personal = Loadable(lazy(() => import('views/user-components/pages/dashboard/Personal')));
const Goals = Loadable(lazy(() => import('views/user-components/pages/dashboard/Goals')));
const Accounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/Accounts')));
const Assets = Loadable(lazy(() => import('views/user-components/pages/dashboard/Assets')));
const IncomeExpenses = Loadable(lazy(() => import('views/user-components/pages/dashboard/IncomeExpenses')));
const EstatePlanning = Loadable(lazy(() => import('views/user-components/pages/dashboard/EstatePlanning')));
const Fees = Loadable(lazy(() => import('views/user-components/pages/dashboard/Fees')));
const AssetAllocationAccounts = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetAllocationAccounts')));

const AccountSummary = Loadable(lazy(() => import('views/user-components/pages/dashboard/AccountSummary')));
const CashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/CashFlow')));
const NetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/NetWorth')));
const FundTransfer = Loadable(lazy(() => import('views/user-components/pages/dashboard/FundTransfer')));
const DataVault = Loadable(lazy(() => import('views/user-components/pages/dashboard/DataVault')));
const AssetDrift = Loadable(lazy(() => import('views/user-components/pages/dashboard/AssetDrift')));
const ProjectedCashFlow = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedCashFlow')));
const ProjectedNetWorth = Loadable(lazy(() => import('views/user-components/pages/dashboard/ProjectedNetWorth')));
const InsuranceCalculator = Loadable(lazy(() => import('views/user-components/pages/dashboard/InsuranceCalculator')));
const FinancialGoal = Loadable(lazy(() => import('views/user-components/pages/dashboard/FinancialGoal')));
// const ThankYouPage = Loadable(lazy(() => import('views/admin-components/pages/admin-client-form/ThankYouPage')));


let loginType = localStorage.getItem('login_type');
let userId = localStorage.getItem('user_id');
let dashboardLogin = localStorage.getItem('dashboard_login');

// console.log(loginType, userId, dashboardLogin)

// only redirect when you get the user_id
let isDashboardLogin = (loginType === 'portfolio_manager' || loginType === 'dashboard_admin' || loginType === 'client') && dashboardLogin ? true : false
const NotFound = () => <div>Page Not Found</div>;

const ClientRoutes = {
    path: '/',
    element: isDashboardLogin ? <DashBoardLayout /> : <Navigate to={`/`} />,
    // element: loginType ? (isDashboardLogin ? <DashBoardLayout /> : <Navigate to={`/`} />) : <Navigate to={`/kyc`} />,
    children: [
        { path: '/home', element: isDashboardLogin ? <Home /> : <Navigate to={`/`} /> },
        { path: '/employee_info', element: isDashboardLogin ? <EmployeeInfo /> : <Navigate to={`/`} /> },
        // { path: '/personal', element: isDashboardLogin ? <Personal /> : <Navigate to={`/`} /> },
        { path: '/assetallocation', element: isDashboardLogin ? <AssetAllocation /> : <Navigate to={`/`} /> },
        { path: '/main', element: isDashboardLogin ? <AssetAllocationHome /> : <Navigate to={`/`} /> },
        { path: '/asset_allocation_accounts', element: isDashboardLogin ? <AssetAllocationAccounts /> : <Navigate to={`/`} /> },
        { path: '/goals', element: isDashboardLogin ? <Goals /> : <Navigate to={`/`} /> },
        { path: '/accounts', element: isDashboardLogin ? <Accounts /> : <Navigate to={`/`} /> },
        { path: '/assets', element: isDashboardLogin ? <Assets /> : <Navigate to={`/`} /> },
        { path: '/fees', element: isDashboardLogin ? <Fees /> : <Navigate to={`/`} /> },
        { path: '/fund-transfer', element: isDashboardLogin ? <FundTransfer /> : <Navigate to={`/`} /> },
        { path: '/income_expenses', element: isDashboardLogin ? <IncomeExpenses /> : <Navigate to={`/`} /> },
        { path: '/estate_planning', element: isDashboardLogin ? <EstatePlanning /> : <Navigate to={`/`} /> },
        // REPORT
        { path: '/account_summary', element: isDashboardLogin ? <AccountSummary /> : <Navigate to={`/`} /> },
        { path: '/cashflow', element: isDashboardLogin ? <CashFlow /> : <Navigate to={`/`} /> },
        { path: '/networth', element: isDashboardLogin ? <NetWorth /> : <Navigate to={`/`} /> },
        { path: '/data_vault', element: isDashboardLogin ? <DataVault /> : <Navigate to={`/`} /> },
        { path: '/message_center', element: isDashboardLogin ? <MessageCenter /> : <Navigate to={`/`} /> },
        { path: '/asset_drift', element: isDashboardLogin ? <AssetDrift /> : <Navigate to={`/`} /> },
        // FINANCIAL PLAN
        { path: '/projected_cash_flow', element: isDashboardLogin ? <ProjectedCashFlow /> : <Navigate to={`/`} /> },
        { path: '/projected_net_worth', element: isDashboardLogin ? <ProjectedNetWorth /> : <Navigate to={`/`} /> },
        { path: '/insurance_calculator', element: isDashboardLogin ? <InsuranceCalculator /> : <Navigate to={`/`} /> },
        { path: '/financial_goals', element: isDashboardLogin ? <FinancialGoal /> : <Navigate to={`/`} /> },
        // { path: '/thanks', element: isDashboardLogin ? <ThankYouPage /> : <Navigate to={`/`} /> },
        { path: '*', element: <NotFound /> },
    ]
};

export default ClientRoutes;
